// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

import React from "react";
// import ReactDOM from "react-dom/client";
import ReactDOM from "react-dom";
import './styles/styles.css'
import App from "./components/App";
import Thumbsup from "./assets/images/thumb-up.png";
import Info from "./assets/images/info.png";
import Thumbsdown from "./assets/images/thumb-down.png";
import closeicon from "./assets/images/close.png";
//import { Provider, themes } from '@fluentui/react-northstar' //https://fluentsite.z22.web.core.windows.net/quick-start

//Redux
// import { createStore } from 'redux';
// import allReducers from './reducers';
// import { Provider } from 'react-redux';
// const store = createStore(
//     allReducers,
//     window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
// );

//React alert
import { transitions, positions, Provider as AlertProvider } from "react-alert";
//import AlertTemplate from "react-alert-template-basic";

let borderattrib = "#fff";
const options = {
  // you can also just use 'bottom center'
  position: positions.BOTTOM_CENTER,
  timeout: 5000,
  offset: "30px",
  // you can also just use 'scale'
  transition: transitions.SCALE,
};

//alert start
const alertStyle = {
  position: "relative",
  // textTransform: "uppercase",
  backgroundColor: "#dddee1",
  borderRadius: "15px",
  display: "flex",
  alignItems: "center",
  boxShadow: "0px 2px 2px 2px rgba(0, 0, 0, 0.03)",
  width: "350px",
  height: "50px",
  boxSizing: "border-box",
  display: "flex",
  overflow: "hidden"
};
const buttonStyle = {
  border: "none",
  backgroundColor: "transparent",
  cursor: "pointer",
  color: "#717171",
  position: "absolute",
  top: "0",
  right: "8px",
  padding: "0"
};
const iconCss = {
  backgroundColor: "#3b3b3b",
  height: "100%",
  width: "60px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderTopLeftRadius: "15px",
  borderBottomLeftRadius: "15px",
}
const errorBoxCss = {
  backgroundColor: "#dddee1",
  display: "flex",
  width: "100%",
  alignContent: "center",
  justifyContent: "center",
};
const errorMessageCss = {
  alignContent: "center",
  justifyContent: "center",
};

const AlertTemplate = ({ message, options, style, close }) => {
  return (
    <div style={{ ...alertStyle, ...style }}>
      {options.type === "info" && (
        <div style={{ borderRight: "5px solid #008bff", ...iconCss }}>
          <img src={Info} alt="Info" style={{ width: "25px" }} />
        </div>
      )}
      {options.type === "success" && (
        <div style={{ borderRight: "5px solid #06D923", ...iconCss }}>
          <img src={Thumbsup} alt="Thumbs up" style={{ width: "25px" }} />
        </div>
      )}
      {options.type === "error" && (
        <div style={{ borderRight: "5px solid #f94848", ...iconCss }}>
          <img src={Thumbsdown} alt="Thumbs down" style={{ width: "25px" }} />
        </div>
      )}
      <div style={{ ...errorBoxCss }}>
        <div style={{ ...errorMessageCss }}>
          <p style={{ marginBottom: "0px", textTransform: "initial" }}>{message}</p>
        </div>
        <div>
          <button onClick={close} style={{ ...buttonStyle }}>
            <img src={closeicon} alt="close" style={{ width: "8px" }} />
          </button>
        </div>
      </div>
    </div>
  );
};
//alert end

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <AlertProvider template={AlertTemplate} {...options}>
//     <App />
//   </AlertProvider>
// );

ReactDOM.render(
  <AlertProvider template={AlertTemplate} {...options}>
    <App />
  </AlertProvider>,
  document.getElementById("root")
);

